import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="pb-20 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-77">
      <FadeIn data-id="element-78">
        <div className="bg-white border-2 border-gray-100 rounded-2xl p-8 md:p-10 text-center shadow-sm" data-id="element-79">
          <div className="w-16 h-16 bg-lightGray rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-80">
            <ShieldCheck className="w-8 h-8 text-navy" data-id="element-81" />
          </div>
          <h3 className="text-2xl font-bold text-navy mb-4" data-id="element-82">
            Más claridad, más preparación, más seguridad
          </h3>
          <p className="text-gray-600 mb-6 text-lg" data-id="element-83">
            Un recurso de bajo riesgo y alto valor que mejorará tu preparación
            de forma inmediata.
          </p>
          <div className="bg-lightGray p-4 rounded-lg border border-gray-200" data-id="element-84">
            <p className="text-navy font-medium italic" data-id="element-85">
              "Una sola idea bien aplicada puede cambiar por completo cómo te
              perciben en una entrevista."
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}